import { Card } from "@salesko/design-system";
import type { ReactNode } from "react";

/**
 * The shared settings panel shell. Each panel is mounted by its own Settings
 * sub-route; the stable id remains useful for accessibility and older inbound
 * links, while the design-system `Card` supplies the visual surface.
 */
export function SettingsSection({
  ariaLabel,
  children,
  id,
  title,
  trailing
}: {
  ariaLabel: string;
  children: ReactNode;
  id: string;
  title: string;
  trailing?: ReactNode;
}) {
  return (
    <section aria-label={ariaLabel} id={id} style={{ scrollMarginTop: 24, maxWidth: 760 }}>
      <Card padding="lg" style={{ display: "grid", gap: "var(--space-4)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
          <p
            style={{
              margin: 0,
              fontFamily: "var(--font-sans)",
              fontSize: "var(--text-label)",
              fontWeight: "var(--fw-bold)",
              letterSpacing: "var(--tracking-wide)",
              textTransform: "uppercase",
              color: "var(--text-secondary)"
            }}
          >
            {title}
          </p>
          {trailing}
        </div>
        {children}
      </Card>
    </section>
  );
}

/** Quiet supporting copy inside a settings panel. */
export function SettingsNote({ children, tone = "muted" }: { children: ReactNode; tone?: "muted" | "body" }) {
  return (
    <p
      style={{
        margin: 0,
        fontFamily: "var(--font-sans)",
        fontSize: "var(--text-body-sm)",
        lineHeight: "var(--leading-normal)",
        color: tone === "muted" ? "var(--text-muted)" : "var(--text-body)"
      }}
    >
      {children}
    </p>
  );
}
